import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant } from 'app.constants';
import { isShowDataExtractor } from './utils/DataExtractorFunctions';
export class DataExtractorController {
    static $inject = ['AccountService2', 'ContextProcessorService', 'DATA_EXTRACTOR_FRAME_URL', 'DATA_EXTRACTOR_REDIRECT_URL', 'DATA_EXTRACTOR_REDIRECT_URL_DASHBOARD', 'LoadingService', '$sce'];
    constructor(AccountService2, ContextProcessorService, DATA_EXTRACTOR_FRAME_URL, DATA_EXTRACTOR_REDIRECT_URL, DATA_EXTRACTOR_REDIRECT_URL_DASHBOARD, LoadingService, $sce) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.ContextProcessorService = ContextProcessorService;
        this.DATA_EXTRACTOR_FRAME_URL = DATA_EXTRACTOR_FRAME_URL;
        this.DATA_EXTRACTOR_REDIRECT_URL = DATA_EXTRACTOR_REDIRECT_URL;
        this.DATA_EXTRACTOR_REDIRECT_URL_DASHBOARD = DATA_EXTRACTOR_REDIRECT_URL_DASHBOARD;
        this.LoadingService = LoadingService;
        this.$sce = $sce;
        this.checkTenantContext = async (ContextProcessorService) => {
            await ContextProcessorService.waitForInitialization();
            const tenantId = this.ContextProcessorService.tenant.id;
            const tenantPlan = await this.AccountService2.getTenantPlan(tenantId);
            const isShowingDataExtractor = await isShowDataExtractor();
            if (tenantPlan.name === 'standard') {
                window.location.replace(this.DATA_EXTRACTOR_REDIRECT_URL);
            }
            else if (!isShowingDataExtractor) {
                window.location.replace(this.DATA_EXTRACTOR_REDIRECT_URL_DASHBOARD);
            }
            else {
                this.frameUrl = this.$sce.trustAsResourceUrl(this.DATA_EXTRACTOR_FRAME_URL);
                this.LoadingService.stopLoading();
            }
        };
        this.user = this.AccountService2.meSync();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        this.LoadingService.startLoading();
        this.checkTenantContext(ContextProcessorService);
    }
}
DataExtractorController.$inject = ['AccountService2', 'ContextProcessorService', 'DATA_EXTRACTOR_FRAME_URL', 'DATA_EXTRACTOR_REDIRECT_URL', 'DATA_EXTRACTOR_REDIRECT_URL_DASHBOARD', 'LoadingService', '$sce'];
